/* global gdAlertify */
import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { fechaHora, haceCuanto, mensajeError } from "./enviosUi";

// Salida a /dev/null: el cron no deja archivo de log (el motor solo anota en el log de la app los ciclos con actividad).
const LINEA_CRON = "*/5 * * * * php /var/www/html/sk-medical-back/bin/procesar-cola-envios.php > /dev/null 2>&1";

const EnviosParametros = ({ ultimoCiclo, onGuardado }) => {
    const [form, setForm] = useState(null);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axiosInstance.get("/envios/parametros");
                setForm(data?.data || null);
            } catch (error) {
                gdAlertify.notiError(mensajeError(error, "No se pudieron cargar los parámetros."));
            }
        })();
    }, []);

    const set = (campo, valor) => setForm((prev) => ({ ...prev, [campo]: valor }));

    const guardar = async () => {
        setGuardando(true);
        gdAlertify.showLoader();
        try {
            const { data } = await axiosInstance.post("/envios/parametros/guardar", {
                ...form,
                activo: form.activo ? 1 : 0,
                modo_demo: form.modo_demo ? 1 : 0,
                cron_instalado: form.cron_instalado ? 1 : 0,
            });
            setForm(data?.data || form);
            gdAlertify.notiSuccess("Parámetros guardados.");
            onGuardado?.();
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudieron guardar los parámetros."));
        } finally {
            gdAlertify.hideLoader();
            setGuardando(false);
        }
    };

    if (!form) {
        return <div className="text-center py-4"><div className="spinner-border text-primary" role="status"></div></div>;
    }

    return (
        <div className="row g-4">
            <div className="col-lg-6">
                <div className="form-check form-switch mb-3">
                    <input className="form-check-input" type="checkbox" id="motor-activo" checked={form.activo} onChange={(e) => set("activo", e.target.checked)} />
                    <label className="form-check-label fw-semibold" htmlFor="motor-activo">
                        Motor encendido
                    </label>
                    <div className="form-text">
                        Apagado, el cron no envía nada (útil ante un error masivo). Los mensajes quedan esperando en la cola.
                    </div>
                </div>

                <div className={`border rounded p-3 mb-4 ${form.modo_demo ? "border-warning bg-warning-subtle" : ""}`}>
                    <div className="form-check form-switch mb-2">
                        <input className="form-check-input" type="checkbox" id="modo-demo" checked={form.modo_demo} onChange={(e) => set("modo_demo", e.target.checked)} />
                        <label className="form-check-label fw-semibold" htmlFor="modo-demo">Modo demo</label>
                    </div>
                    <div className="form-text mb-3">
                        Encendido, <strong>todo</strong> lo que salga (pruebas y lotes reales) se envía a estos destinos en vez de a los
                        destinatarios reales, y no se marca nada como notificado. El destinatario original queda en el historial.
                        Apágalo solo cuando quieras que lleguen a pacientes y familias.
                    </div>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">Correo demo</label>
                            <input className="form-control" value={form.demo_email} onChange={(e) => set("demo_email", e.target.value)} placeholder="correo@ejemplo.cl" />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">WhatsApp demo</label>
                            <input className="form-control" value={form.demo_telefono} onChange={(e) => set("demo_telefono", e.target.value)} placeholder="+56912345678" />
                        </div>
                    </div>
                </div>

                <div className="border rounded p-3 mb-4">
                    <div className="fw-semibold mb-2"><i className="bi bi-whatsapp text-success me-2"></i>Plantillas de notificación de honorarios</div>
                    <div className="row g-3">
                        <div className="col-md-4">
                            <label className="form-label">Fin de mes (aprobada en YCloud)</label>
                            <input className="form-control" value={form.plantilla_honorarios || ""} onChange={(e) => set("plantilla_honorarios", e.target.value)} placeholder="honorarios_fm_sk" />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Adelanto (aprobada en YCloud)</label>
                            <input className="form-control" value={form.plantilla_honorarios_adelanto || ""} onChange={(e) => set("plantilla_honorarios_adelanto", e.target.value)} placeholder="notificacion_honorarios_skmc" />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Idioma</label>
                            <input className="form-control" value={form.plantilla_honorarios_idioma || ""} onChange={(e) => set("plantilla_honorarios_idioma", e.target.value)} placeholder="es_CL" />
                        </div>
                    </div>
                    <div className="form-text">
                        Deben tener encabezado de imagen. Variables: <code>{"{{nombre}}"}</code>, <code>{"{{periodo}}"}</code>,{" "}
                        <code>{"{{tipo_pago}}"}</code>, <code>{"{{mes}}"}</code>, <code>{"{{liquido}}"}</code> (a pagar) y{" "}
                        <code>{"{{total}}"}</code>: bruto de la boleta si la plantilla también usa <code>{"{{liquido}}"}</code>; si no, el líquido a pagar.
                    </div>
                </div>

                <div className="row g-3 mb-3">
                    <div className="col-6">
                        <label className="form-label fw-semibold">Enviar desde</label>
                        <input type="time" className="form-control" value={form.horario_desde} onChange={(e) => set("horario_desde", e.target.value)} />
                    </div>
                    <div className="col-6">
                        <label className="form-label fw-semibold">Enviar hasta</label>
                        <input type="time" className="form-control" value={form.horario_hasta} onChange={(e) => set("horario_hasta", e.target.value)} />
                    </div>
                    <div className="col-12 form-text mt-1">Hora de Chile. Fuera de este horario lo encolado espera al día siguiente.</div>
                </div>

                <div className="mb-3">
                    <label className="form-label fw-semibold">Minutos para considerar un envío colgado</label>
                    <input type="number" min="1" max="240" className="form-control" style={{ maxWidth: 160 }}
                        value={form.minutos_bloqueo} onChange={(e) => set("minutos_bloqueo", e.target.value)} />
                    <div className="form-text">
                        Si un mensaje queda en Procesando más que esto (el proceso se cortó): un correo vuelve a la cola;
                        un WhatsApp queda Fallido para revisarlo antes de reintentar y no duplicarlo.
                    </div>
                </div>

                <button className="btn btn-primary" onClick={guardar} disabled={guardando}>
                    <i className="bi bi-save me-1"></i>Guardar parámetros
                </button>
            </div>

            <div className="col-lg-6">
                <h6 className="fw-semibold">Cron del servidor</h6>
                <div className="form-check form-switch mb-2">
                    <input className="form-check-input" type="checkbox" id="cron-instalado" checked={!!form.cron_instalado}
                        onChange={(e) => set("cron_instalado", e.target.checked)} />
                    <label className="form-check-label" htmlFor="cron-instalado">El cron está instalado en el servidor</label>
                    <div className="form-text">
                        Apagado: la cola se procesa a mano con <strong>Procesar cola ahora</strong> y no hay aviso de cron atrasado.
                        Encendido: se avisa si pasan más de 12 min sin un ciclo. Guarda con el botón de la izquierda.
                    </div>
                </div>
                <p className="small text-muted mb-2">Para instalarlo, esta línea en el crontab (no deja archivo de log):</p>
                <pre className="small bg-light border rounded p-2" style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{LINEA_CRON}</pre>

                <h6 className="fw-semibold mt-4">Último ciclo</h6>
                {ultimoCiclo ? (
                    <>
                        <p className="small mb-1">{fechaHora(ultimoCiclo.fecha)} ({haceCuanto(ultimoCiclo.fecha)}){ultimoCiclo.resumen?.forzado ? " · manual" : ""}</p>
                        <pre className="small bg-light border rounded p-2" style={{ whiteSpace: "pre-wrap" }}>
                            {JSON.stringify(ultimoCiclo.resumen, null, 2)}
                        </pre>
                    </>
                ) : (
                    <p className="small text-muted">Todavía no ha corrido ningún ciclo.</p>
                )}
            </div>
        </div>
    );
};

export default EnviosParametros;
